import React, { Fragment } from 'react';
import { Route } from 'react-router-dom';
import { DuplicateTagVerificationAddEdit, DuplicateTagVerificationFiltering } from './Pages';

export const DuplicateTagVerificationRoutes = ({ match }) => (
    <Fragment>
        <Route exact path={`${match.path}`} component={DuplicateTagVerificationFiltering} />
        <Route exact path={`${match.path}/AddEdit`} component={DuplicateTagVerificationAddEdit} />
    </Fragment>
)